import React from "react";

const ArticleTable = ({ table }) => {
  if (!table?.Column || table.Column.length === 0) return null;

  const columns = table.Column;
  const maxRows = Math.max(...columns.map((col) => col.Row?.length || 0));

  return (
    <div className="overflow-x-auto my-6">
      <table className="w-full border-collapse text-sm border border-gray-200">
        <thead>
          <tr>
            {columns.map((col) => (
              <th
                key={col.id}
                className="px-4 py-2 text-left font-bold text-gray-700 bg-gray-50 border-b border-r border-gray-200 last:border-r-0"
              >
                {col.Column_Name || `Column ${col.id}`}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: maxRows }).map((_, rowIndex) => (
            <tr
              key={rowIndex}
              className="hover:bg-gray-50 border-b border-gray-100 last:border-0"
            >
              {columns.map((col) => (
                <td
                  key={col.id}
                  className="px-4 py-2 text-gray-700 border-r border-gray-200 last:border-r-0"
                >
                  {col.Row?.[rowIndex]?.Row_Content || ""}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ArticleTable;